import React from "react";
import { SgSpinner } from "../SgSpinner";
import "./IonicBubblesLoading.scss";

/**
 * Ionic ion-loading（md）复刻：全屏黑 32% 遮罩 + 居中 #0d0d0d 小方盒（padding 24、radius 2、投影）+
 * 28px 金色 #fbc63d spinner（形态走 SgSpinner：后台 homeLayout.loadingSpinner，缺省 bubbles）。
 * fixed 全屏，覆盖在当前页之上（竞品 Tab 切换 / 拉数据时都是这一个）。
 */
export const IonicBubblesLoading: React.FC<{
  className?: string;
  style?: React.CSSProperties;
}> = ({ className = "", style }) => (
  <div
    className={`ionic-loading ${className}`.trim()}
    style={style}
    role="dialog"
    aria-modal="true"
  >
    <div className="ionic-loading__backdrop" />
    <div className="ionic-loading__box">
      <SgSpinner size={28} className="ionic-loading__spinner" />
    </div>
  </div>
);

export default IonicBubblesLoading;
